import React, { Component } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import pym from 'pym.js'

import AutoComplete from './Autocomplete';
import Histogram from './Histogram';
import Table from './Table';

import './App.css';
import values from './values.json';
import schools from './schools.json';

const schoolNames = schools.map(({label}) => label);

const pymChild = new pym.Child();

const theme = createMuiTheme({
  palette: {
    primary: {
      light: '#efefef',
      main: '#bdbdbd',
      dark: '#8d8d8d',
      contrastText: '#111',
    },
    secondary: {
      light: '#ffffff',
      main: '#e3f2fd',
      dark: '#b1bfca',
      contrastText: '#111',
    }
  },
});

class App extends Component {
  state = {
    allValues: values,
    values: values.filter(() => true),
    donations: null,
    totals: null,
    allData: null,
    school: null,
    state: true,
    integrated: true,
    primary: true,
    intemediate: true,
    composite: true,
    secondary: true,
    width: 320
  }
  componentDidMount = () => {
    import('./data.json')
      .then((d) => {
        this.setState({allData: d})
      })
    import('./totals.json')
      .then((d) => {
        this.setState({totals: d});
      })
    import('./donations.json')
      .then((d) => {
        this.setState({donations: d});
      })
  }

  setSchool = name => {
    if (schoolNames.indexOf(name) !== -1) {
      this.setState({school: this.state.allData[name]})
    } else {
      this.setState({school: null})
    }
  }

  _onResize = w => {
    pymChild.sendHeight();
    this.setState({width: w})
  }
  render() {
    return (
      <MuiThemeProvider theme={theme} >
        <div className="App">
          <Histogram data={this.state.values} width={this.state.width}
            highlight={this.state.school && this.state.school["Per Student"]}/>
          <div className="controls">
            <AutoComplete send={this.setSchool} />
          </div>
          {this.state.school && <Table school={this.state.school} />}
          <ReactResizeDetector handleWidth handleHeight onResize={this._onResize} />
        </div>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js